import React from 'react';
import foodbrand from '../assets/foodbrand@2x.png';

function Footer({ imgBack, rutaBack }) {

    return (
        <>
            <div className="footer">
                <div className='containerCont_P27'>
                    <div className='imageContainer_P2'>
                        <img src={foodbrand} className='imgFooter_P2' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
